<template>
  <header>
    <div class="logoBg">
      <img :src="require('../assets/logoLefts.png')" alt="" class="logoLeft"  width="345px" height="45px"/>
      <img :src="require('../assets/logoRights.png')" alt="" class="logoRight"   width="221px" height="122px"/>
      <div class="logoMenu">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          active-text-color="#176DAA"
          @select="handleSelect"
          text-color="#333333"
        >
          <el-menu-item index="1"
          ><span>首页</span></el-menu-item
          >
          <template v-for="item in navList">
            <el-menu-item :index="item.id" v-if="!item.children" :key="item.id"
            ><span>{{ item.text }}</span></el-menu-item
            >
            <el-submenu popper-class="submenu"
              :index="item.id"
              v-if="item.children && item.children.length > 0"
              :key="item.id">
              <template slot="title"
              ><span @click="toList(item.id)">{{
                  item.text
                }}</span></template
              >
              <template v-for="child1 in item.children">
                <el-menu-item
                  :key="child1.id"
                  :index="child1.id"
                  v-if="!child1.children"
                >
                  <span >{{ child1.text }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="loginDiv" @click="checkLogInDialog">
        <img :src="require('../assets/logins.png')" alt="" width="18px" height="20px" style="margin-right: 8px"/>
        <span  v-if="loginStatus != 2">登录</span>
        <el-popover
          placement="bottom"
          width="300"
          trigger="hover"
          v-if="loginStatus == 2"
        >
          <div class="teacherInfoList">
            用户类型：<span v-if="userInfo.schType == 's'">学生</span
            ><span v-if="userInfo.schType == 't'">教工</span>
          </div>
          <div class="teacherInfoList">
            工、学号：{{ userInfo.userJobNumber }}
          </div>
          <div class="teacherInfoList">
            机构：<span v-for="(item, index) in userInfo.orgInfos" :key="index">{{
              item.orgName
            }}</span>
          </div>
          <div class="load">
            <div
              class="teacherbutton"
              style="color: #348f71"
              @click="goMainSys"
            >
              进入系统
            </div>
            <div class="teacherbutton" style="color: #348f71" @click="goOut">
              <a
                :href="
                  '/mainsys/cmsapi/logout.do?siteName=' + siteInfo.siteName
                "
                >退出登录</a
              >
            </div>
          </div>
          <div v-if="loginStatus == 2" slot="reference" style="width: 65px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" :title="userInfo.name">{{
            userInfo.name
          }}</div>
        </el-popover>
      </div>
    </div>
      <el-dialog title="用户登录" :visible.sync="openLogin" width="500px" :append-to-body="true">
        <div style="margin: 0 auto; width: 360px">
          <el-form
            :rules="loginRules"
            ref="loginForm"
            :model="loginForm"
            label-position="top"
            size="small"
            style="width: 360px"
          >
            <el-form-item prop="userName">
              <el-input
                v-model="loginForm.userName"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="密码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div style="display: flex; width: 100%">
                <el-input
                  v-model="loginForm.code"
                  placeholder="验证码"
                  style="width: 280px"
                ></el-input
                >&nbsp;&nbsp;
                <img
                  id="codeBox"
                  height="28px"
                  width="100px"
                  style="vertical-align: middle; cursor: pointer"
                  border="0"
                  :src="checkCodeSrc"
                  @click="changeCode"
                />
              </div>
            </el-form-item>
            <div style="text-align: center; margin-top: 28px">
              <el-button
                @click="submitLoginInfo"
                class="normolBotton"
                size="small"
                >登录</el-button
              >
              <el-button @click="openLogin = false" size="small"
                >取消</el-button
              >
            </div>
          </el-form>
        </div>
      </el-dialog>
  </header>
</template>

<script>
import md5 from "js-md5"; //md5
export default {
  data() {
    return {
      activeIndex: "1",
      navList: [],
      loginStatus: 1, //1-未登录 2-已登录
      userInfo: {}, //用户信息
      childrenIndex:0,
      loginForm: {
        userName: "",
        password: "",
        code: "",
      },
      openLogin: false,
      loginRules: {
        userName: [
          { required: true, message: "请输入登陆名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      checkCodeSrc: this.GlobalConfig.baseUrl + "/login/login_code.jsp", //验证码Url
    };
  },
  methods: {
    checkLogInDialog(){
      if(this.loginStatus != 2) {
        this.openLogin = true
      }
    },
    handleSelect(menuId) {
      let name = "";
      let idx=''
      this.navList.forEach((item) => {
        if (menuId != item.id) {
          if (item.children && item.children.length > 0) {
            item.children.forEach((val,index) => {
              if (val.id == menuId) {
                name = item.text;
                idx=index
              }
            });
          }
        }
      });
      if (name == "教学资源") {
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: menuId, menuIndex:idx},
        });
      } else {
        if (menuId == "1") {
          this.$router.push({
            path: "/",
          });
        } else {
          this.$router.push({
            path: "List:menuId",
            name: "List",
            params: { menuId: menuId, menuIndex:idx},
          });
        }
      }
    },

    toList(menuId) {
      console.log(this.navList, menuId)
      this.activeIndex = menuId;
      let ids = "";
      this.navList.forEach((item) => {
        if (menuId == item.id) {
          ids = menuId;
        }
      });
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: ids},
      });
    },
    submitLoginInfo() {
      //提交登陆信息
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          //form data表单提交
          let fd = new FormData();
          fd.append("userName", this.loginForm.userName);
          fd.append("password", md5(this.loginForm.password));
          fd.append("code", this.loginForm.code);
          axios
            .post("/userLogin", fd)
            .then((response) => {
              let data = response.data; //数据
              localStorage.setItem("headStatus", "nav");
              if (data.code == 2) {
                //刷新当前页面
                location.reload();
              } else if (data.code == 3) {
                this.$message.error("密码多日未变，请修改密码");
                setTimeout(() => {
                  location.reload();
                }, 2000);
              }  else throw data.code;
            })
            .catch((error) => {
              //console.log(error);
              if (error == -2) {
                this.$message.error("您的账号在审核状态中，请耐心等待");
              } else if (error == -1) {
                this.$message.error("您的账号已被管理员锁定");
              } else if (error == -3) {
                this.$message.error("用户名或密码错误");
              } else if (error == -4) {
                this.$message.error("验证码错误");
              } else {
                this.$message.error("与服务器断连接！");
              }
              this.changeCode();
            });
        } else {
          return false;
        }
      });
    },
    changeCode() {
      let dt = new Date().getTime();
      // document.getElementById('codeBox').src='/login/login_code.jsp?dt='+dt;
      this.checkCodeSrc =
        this.GlobalConfig.baseUrl + "/login/login_code.jsp?dt=" + dt;
      this.loginForm.code = ""; //验证码框置空
    },
    getNavList() {
      axios
        .post("/cmsapi/getSiteFirstMenu")
        .then((res) => {
          if (res.data[0]) this.navList = res.data[0].children;
        })
        .catch((error) => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    goMainSys() {
      //进入主系统
      location.href = this.targetUrl;
    },
    goOut() {
      let fd = new FormData();
      fd.append("siteName", this.siteInfo.siteName);
      axios.post("/cmsapi/logout.do", fd).then((res) => {
        //   this.loginStatus = 1
        // localStorage.clear()
        // sessionStorage.clear()
        // location.reload()
      });
    },
  },
  created() {
    this.$nextTick(() => {
      //获取当前用户登录状态
      axios
        .post("/getUserLoginInfo")
        .then((response) => {
          let data = response.data; //数据
          if (data.code > 0) {
            this.loginStatus = data.code;
            sessionStorage.setItem("loginStatus", data.code);
            sessionStorage.setItem("schType", data.data.schType);
            sessionStorage.setItem("userId", data.data.userId);
            if (data.code == 2) this.userInfo = data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
      this.getNavList();
    });
  },
};
</script>

<style scoped>
header {
  height: 122px;
  width: 100%;
}
.logoBg {
  height: 100%;
  width: 100%;
  position: relative;
}
.logoLeft {
  position: absolute;
  left: 40px;
  top: 18px;
}
.logoRight {
  position: absolute;
  right: 176px;
  top: 0px;
}
.logoMenu{
  height: 100%;
  width: calc(100% - 900px);
  position: absolute;
  left: 450px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loginDiv {
  position: absolute;
  right: 40px;
  top: 35px;
  width: 112px;
  height: 53px;
  background: #176DAA;
  border-radius: 26.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.loginDiv span {
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  font-size: 20px;
  color: #fff;
}

.logoMenu >>> .el-menu {
  display: flex !important;
  justify-content: center !important;
}
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  text-decoration: none !important;
  height: 50px !important;
  line-height: 50px !important;
  padding: 0 40px !important;
}
.el-menu-item {
  font-size: 20px !important;
}
.logoMenu >>> .el-submenu__title {
  font-size: 20px !important;
  border-bottom: 0px solid #409eff !important;
}
.logoMenu >>> .el-submenu__title .el-icon-arrow-down {
  display: none !important;
}
.logoMenu >>> .el-menu.el-menu--horizontal{
  border-bottom: 0px solid #409eff !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
  font-weight: 700 !important;
  border-bottom: 0px solid #409eff !important;
}
.el-menu--horizontal>.el-menu-item.is-active::after {
  content: '';
  width:50%;
  height: 0px;
  display: block;
  margin: 0 auto;
  border-bottom: 2px solid #176DAA;
}
.logoMenu >>> .el-menu--horizontal>.el-submenu .el-submenu__title{

  height: 50px !important;
  line-height: 50px !important;
}
.logoMenu >>> .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  font-weight: 700 !important;
  border-bottom: 0px solid #409eff !important;
}
.logoMenu >>> .el-menu--horizontal>.el-submenu.is-active .el-submenu__title::after{
  content: '';
  width:50%;
  height: 0px;
  display: block;
  margin: 0 auto;
  border-bottom: 2px solid #176DAA;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  text-align: center !important;
  font-size: 20px !important;
  height: 40px !important;
}

.teacherInfoList {
  height: auto;
  width: 80%;
  padding-left: 20px;
  padding-top: 10px;
  font-size: 12px;
}
.load {
  height: 35px;
  width: 100%;
  display: flex;
  background-color: #ebebeb;
  justify-content: center;
  margin-top: 10px;
}
.teacherbutton {
  width: 49%;
  height: 100%;
  color: #034da4;
  font-size: 12px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
}
</style>
<style>
.submenu .el-menu--popup{
  min-width: 163px !important;
  box-shadow: 0 2px 4px 0 #00000026 !important;
  border-radius: 6px !important;
}
.submenu .el-menu .el-menu-item:not(.is-disabled):hover{
  background: #176daa29 !important;
  font-weight: 700 !important;
  color: #176DAA !important;
}
</style>
